import { OccConfig } from '@spartacus/core';

import { GOOGLE_TAG_MANAGER_ID } from '@app-shared/google-tag-manager/google-tag-manager.tokens';
import { environment } from '@app-src/environments/environment';


const PRODUCTION_BASE_URL = 'api.dormerpramet.com';

export const ANGULAR_GOOGLE_TAG_MANAGER_PROVIDER = {
  provide: GOOGLE_TAG_MANAGER_ID,
  useFactory: (config?: OccConfig): string | undefined =>
    config?.backend?.occ?.baseUrl?.includes(PRODUCTION_BASE_URL)
      ? environment.googleTagManagerId
      : environment.spareGoogleTagKey,
  deps: [OccConfig]
};
